module.exports = __webpack_public_path__ + "img/logo.e57d1dbb.png";